import React, { useContext, useEffect } from 'react'
import Classes from "../../components/classesComponent/classesComponent"
import ContactImg from "../../components/condactForm/contact"
import { contextData } from '../../App'


function ClassesPage() {

  const {isScrolled,setIsScrolled} = useContext(contextData);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsScrolled(true)
    return () => {
      setIsScrolled(false)
    }
  },[])

  return (
    <div className='pt-[204px] pb-[204px]'>
      <Classes/>
    </div>
  )
}

export default ClassesPage
